import { Injectable } from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {AbstractEvent} from '../../shared/interfaces/abstract-event';
import {AngularFireFunctions} from '@angular/fire/functions';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private afn: AngularFireFunctions,) { }


  /**
   * 開発者へのメール送信処理
   * @param mailText
   */
  sendMailToDeveloper(mailText: string) {
    console.log('sendMailToDeveloper start.');
    firstValueFrom(this.afn.httpsCallable('notification-sendNotification-sendMailToDeveloper')(mailText))
      .then(res => console.log(res))
      .catch(res => console.log(res));
  }

  /**
   * イベントの取消時のメール本文を生成
   * @param event
   */
  genMailTextForEventUndo(event: AbstractEvent) {
    const data = JSON.stringify(event, null, 2);
    const mailText =
      `${event.eventName}の取消が実行されました。
      ${data}`;
    return mailText;
  }
}
